<template>
  <BaseDataTable
    :headers="headers"
    :paginatedItems="paginatedQuestions"
    @debouncedSearch="(searchKey) => setSearchNFetch(searchKey)"
    @optionsChanged="(options) => setTableOptionsNFetch(options)"
    table-key="table:careerAptitudeTestQuestions"
  >
    <template v-slot:actions="{ item }">
      <DeleteCATQuestionButton :item="item" />
      <EditCATQuestionButton :item="item" />
    </template>
    <template v-slot:[`item.adderName`]="{ item }">
      <RouterLink v-if="hasPermission(showAdminPermission)" :to="'/admins/'+item.adderId">
        {{ item.adderName }}
      </RouterLink>
      <label v-else> {{ item.adderName }}</label>
    </template>
  </BaseDataTable>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useCareerAptitudeTestQuestionsStore } from "../store/CareerAptitudeTestQuestionsStore";
import DeleteCATQuestionButton from "./action_buttons/DeleteCATQuestionButton.vue";
import EditCATQuestionButton from "./action_buttons/EditCATQuestionButton.vue";
import { RouterLink } from "vue-router";
import PermissionManagerMixin from "@/core/mixins/PermissionManagerMixin.vue";
import { READ_ADMINS_PERMISSION } from "@/core/statics/Permissions";

export default {
  mixins:[PermissionManagerMixin],
  computed: {
    ...mapState(useCareerAptitudeTestQuestionsStore, ["paginatedQuestions"]),
    ...mapWritableState(useCareerAptitudeTestQuestionsStore,["searchKey"]),
  },
  data() {
    return {
      showAdminPermission:READ_ADMINS_PERMISSION,
      //TODO make sure what cols are sortable
      headers: [
        { text: "الرقم", align: "start", value: "id" },
        { text: "نص السؤال", value: "question" },
        { text: "نمط السؤال", value: "type" },
        { text: "أضافه", value: "adderName" },
        { text: "تاريخ الإضافة", value: "createdAt" },
        { text: "الإجراءات", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchQuestions()
      .then()
      .catch((err) => console.error(err));
  },
  methods: {
    ...mapActions(useCareerAptitudeTestQuestionsStore, [
      "fetchQuestions",
      "setSearchNFetch",
      "setTableOptionsNFetch",
    ]),
  },
  components: { DeleteCATQuestionButton, EditCATQuestionButton,RouterLink },
  destroyed(){
    this.searchKey=null;
  }
};
</script>
